const ProfilePreviewSection = ({ profileData }) => {
  if (!profileData) return null;

  const formatWebsiteList = (w1, w2) => {
    const websites = [];
    if (w1) websites.push(w1);
    if (w2) websites.push(w2);
    return websites;
  };

  return (
    <div className="w-full md:w-[380px] bg-[#f0f2f5] dark:bg-gray-800 p-6 hidden md:flex md:flex-col overflow-y-auto shrink-0">
      <div className="bg-white dark:bg-gray-900 border border-slate-200 dark:border-gray-700 overflow-hidden shadow-sm rounded-[12px]">
        {/* Mock App Header */}
        <div className="flex items-center px-4 py-3 border-b border-slate-100 dark:border-gray-700">
          <svg
            className="w-5 h-5 text-slate-600 dark:text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M20 12H4M4 12L10 6M4 12L10 18"
            />
          </svg>
          <svg
            className="w-5 h-5 ml-auto text-slate-600 dark:text-gray-400"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
          </svg>
        </div>

        {/* Mock Profile Card */}
        <div className="p-6 flex flex-col items-center text-center border-b border-slate-100 dark:border-gray-700">
          <div className="h-[100px] w-[100px] rounded-full bg-slate-800 dark:bg-gray-700 flex items-center justify-center overflow-hidden mb-4 shadow-sm">
            {profileData.profileImage ? (
              <img
                src={profileData.profileImage}
                alt="profile"
                className="h-full w-full object-cover"
              />
            ) : (
              <div className="h-full w-full flex items-center justify-center bg-slate-900 dark:bg-gray-600 text-3xl font-semibold text-white">
                {profileData.displayName?.charAt(0)?.toUpperCase() || "B"}
              </div>
            )}
          </div>
          <h3 className="text-lg font-medium text-slate-900 dark:text-gray-100 flex items-center gap-1.5 justify-center">
            {profileData.displayName}
          </h3>
          <p className="text-sm text-slate-500 dark:text-gray-400 mt-1">{profileData.phone || "+1 234 567 8900"}</p>

          <div className="flex items-center gap-2 text-[#00a884] mt-4 cursor-pointer">
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
              />
            </svg>
            <span className="text-sm font-medium">Share</span>
          </div>
        </div>

        {/* Mock Details */}
        <div className="px-5 py-4 space-y-4">
          {profileData.category && (
            <div className="flex items-start gap-4">
              <svg className="h-5 w-5 text-slate-400 dark:text-gray-500 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              <div className="text-sm text-slate-900 dark:text-gray-100">{profileData.category}</div>
            </div>
          )}




          {profileData.description && (
            <div className="flex items-start gap-4">
              <svg className="h-5 w-5 text-slate-400 dark:text-gray-500 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <div className="text-sm text-slate-900 dark:text-gray-100 leading-snug">
                {profileData.description}
              </div>
            </div>
          )}

          {profileData.address && (
            <div className="flex items-start gap-4">
              <svg className="h-5 w-5 text-slate-400 dark:text-gray-500 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <div className="text-sm text-slate-900 dark:text-gray-100 leading-snug">
                {profileData.address}
              </div>
            </div>
          )}

          {profileData.email && (
            <div className="flex items-start gap-4">
              <svg className="h-5 w-5 text-slate-400 dark:text-gray-500 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <div className="text-sm text-slate-900 dark:text-gray-100">
                {profileData.email}
              </div>
            </div>
          )}

          {(profileData.website1 || profileData.website2) && (
            <div className="flex items-start gap-4">
              <svg className="h-5 w-5 text-slate-400 dark:text-gray-500 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
              </svg>
              <div className="text-sm space-y-1.5 w-full overflow-hidden">
                {formatWebsiteList(profileData.website1, profileData.website2).map((website, index) => (
                  <div key={index} className="text-blue-600 dark:text-blue-400 hover:underline cursor-pointer truncate">
                    {website}
                  </div>
                ))}
              </div>
            </div>
          )}

        </div>
      </div>
      <p className="text-center text-xs text-slate-400 dark:text-gray-500 mt-4">
        This experience may look different across devices.
      </p>
    </div>
  );
};

export default ProfilePreviewSection;